// export const apiUrl = "http://23.227.206.234:5014";

export const apiUrl = () => {
  let url;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  console.log("environment", environment);
  switch (environment) {
    case "production":
      url = "https://medimetrics-staging.quantumparadigm.io";
      break;
    case "development":
      // url = "http://23.227.206.234:5020";
      url = "https://medimetrics-staging.quantumparadigm.io";
      // url = "http://192.168.1.11:2022";
      break;
    case "staging":
      url = "https://medimetrics-staging.quantumparadigm.io";
      break;
    case "stagingLive":
      url = "https://medimetrics-staging.quantumparadigm.io";
      break;
    default:
      url = "https://medimetrics-staging.quantumparadigm.io";
  }

  console.log("Base URL", url);
  return url;
};

export const imageUrl = (url) => `${apiUrl()}/api/images/${url}`;
/**
 *
 * @param {String} link
 * @returns {String}
 */
export const BaseURL = (link) => `${apiUrl()}/api/${link}`;

export const apiHeader = (token, isFormData) => {
  if (token && !isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  } else if (token && isFormData) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };
  } else if (!token && !isFormData) {
    return {
      headers: {
        "Content-Type": "application/json",
      },
    };
  } else if (!token && isFormData) {
    return {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
  }
};
